import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [light, setLight] = useState(() => localStorage.getItem("lci-theme") === "light");
  useEffect(() => {
    localStorage.setItem("lci-theme", light ? "light" : "dark");
  }, [light]);
  const toggle = () => setLight((v) => !v);
  return (
    <ThemeContext.Provider value={{ light, setLight, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
